
import AdminNavbarButton from './AdminNavbarButton';

export default function AdminNavbar({display, setDisplay, theme}) {
    const navbarBtns = [
        {
            title:"רשימת לקוחות",
            displayNum:0
        },
        {
            title:"רשימת אתרים",
            displayNum:1
        },
        {
            title:"סטטיסטיקה",
            displayNum:2
        },
    ];
  return (
    <div className='adminNavbar'>
        {navbarBtns.map((btn, inx)=>{
            return <AdminNavbarButton key={`adminNavbarButton_inx_${inx}`} btn={btn} setDisplay={setDisplay} theme={theme} display={display}/>
        })}
    </div>
  )
}
